import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";

import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import { AiOutlineArrowRight } from "react-icons/ai";

import MSMEaccordion from "./MSMEaccordion";
import { question } from "./MSMEData";
import { useEffect } from "react";

const MSMELoan = () => {
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/msme2.png";
const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/msme-banner.png";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const accountContent =
    "The MSME Sector is the corner stone of any great economy. With our brand promise of supporting you developing Zambia, we firmly on board to act as a catalyst for the economic development of Zambia through our MSME Loan Scheme.";
  return (
    <>
      <Breadcrumb
        Heading="MSME Loan"
        img={BackgroundBrundcrumb}
        show={true}
        btnTxt="Apply Now"
      />
      <SavePlusAccountComponent
        heading="MSME Loan"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      <section
        className="page-contains-area"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-contains-box">
                <div className="page-contains-btn">
                  <ul className="navigation clearfix scroll-nav">
                    <li className="current">
                      <a href="#benefits">
                        <img src={Arrow_down} className="me-1" />
                        Eligibility
                      </a>
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="MSMEAccodion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box my-5">
              {question.map((item) => {
                const { id } = item;
                return <MSMEaccordion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>
      <div className="container">
        <div
          className="bg-light my-3"
          style={{
            padding: "20px 0px 20px 60px",
          }}
        >
          <h6 style={{ color: "#9E1B1E" }}>Terms and Conditions Apply</h6>
        </div>
      </div>
      <AllAcountsSection />
    </>
  );
};

export default MSMELoan;
